import { createFileRoute } from '@tanstack/react-router'

import i18n from '@/i18n'
import {
  SchoolYearDetailsView,
  schoolYearQueryOptions
} from '@/modules/schoolSettings'
import { getMetaWithPageTitle } from '@/utils/get-page-title'

export const Route = createFileRoute('/_auth/school-settings/years/$yearId/')({
  component: SchoolYearDetailsView,
  loader: async ({ context, params }) => {
    const { name } = await context.queryClient.ensureQueryData(
      schoolYearQueryOptions(params.yearId)
    )
    return name
  },
  head: ({ loaderData }) =>
    getMetaWithPageTitle([
      loaderData,
      i18n.t('title.details', { ns: 'schoolSettings' })
    ])
})
